import { render, staticRenderFns } from "./CellRendererOpinion.vue?vue&type=template&id=63ce8f70"
import script from "./CellRendererOpinion.vue?vue&type=script&lang=js"
export * from "./CellRendererOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports